<div class="notifications collapse show modal" style="top: auto; bottom: auto; left: auto; padding: unset" *ngIf="isOpen">
    <div class="notifications-header">
      <div class="d-flex align-items-center">
        <div class="circle-progress mr-1"></div>
        <div class="notifications-header-title">In Progress</div>
      </div>
      <div class="notifications-header-options">
        <div class="btn btn-xs" data-toggle="collapse" data-target="notifications" (click)="dismissModal()">
            <svg ycnIcon name="icon-close"></svg>
        </div>
      </div>
    </div>
    <div class="overflow-auto">
      <table class="table table-airy">
        <tbody>
          <tr ycn-background-jobs-progress-popover-item *ngFor="let progress of jobsInProgress() | keyvalue: progressOrdering; trackBy: trackByJobId"
            [progress]="progress.value">
          </tr>
        </tbody>
      </table>
    </div>
</div>
